<template>
  <div>
    <page-table />
  </div>
</template>
<script>
import PageTable from "../pendingPlanPackage/components/table"
export default {
  name: "purchase-pendingPlanPackage",
  components: { PageTable },
  
}
</script>
